import axiosProvider from "./axios-interceptor.js";

function logApiCall(logType, jsonData) {
    const headers = { headers: { "Content-Type": "application/json" } };
    try{
        axiosProvider.post(`/api/v3headerlogger/${logType}`, jsonData, headers);
    }
    catch(error){
       console.log("Error occured on logging");
    }
}

function eventLog(eventName){
    const jsonData = {eventName : eventName};
    logApiCall("event", jsonData);
}

function errorLog(jsonData){
    logApiCall("error", jsonData);
}

function pushGAEvent(eventData) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
        eventData
    );
};

export default{
    eventLog,
    errorLog,
    pushGAEvent
};